import src from "IMAGE";
export default { src, width: 256, height: 315, blurWidth: 0, blurHeight: 0};
